import { render, staticRenderFns } from "./WaybillItemBatch.vue?vue&type=template&id=2a8c2e60&scoped=true&"
import script from "./WaybillItemBatch.vue?vue&type=script&lang=js&"
export * from "./WaybillItemBatch.vue?vue&type=script&lang=js&"
import style0 from "./WaybillItemBatch.vue?vue&type=style&index=0&id=2a8c2e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c2e60",
  null
  
)

export default component.exports